export default {
    transfersSelected: [],
    operationsSelected: [],
    groupedSelected: false,
    uuidGroupedSelected: null,
    suggestions: false,
    disableGroups: false,
    comment: null,
    margin: 0,
    searchBy: false,
    disableAll: false
};
